import { SelectionItemEvent } from '@enums/event';
import { FAVORITE_PROPOSAL_EVENT, PROPOSAL_EVENT } from '@molecules/constants';
import { eventBus } from '@tools/event-bus';
import { flashBagError } from '@tools/flashbag';
import { Logger } from '@tools/logger/logger';

let locked = false;

const isButtonActive = (button) => button.firstChild.classList.contains('active');

const getButtonProposalId = (button) => button.dataset.proposalId ?? null;

const getButtonHashIds = (button) => button.dataset.hashIds ?? null;

const updateButtonLabel = (isActive, button, data) => {
  if (data === undefined) {
    return;
  }

  if (!button.dataset.disableLabel) {
    // eslint-disable-next-line no-param-reassign
    button.innerText = data.label;
  }

  if (isActive && button.dataset.activeText) {
    // eslint-disable-next-line no-param-reassign
    button.lastChild.innerText = button.dataset.activeText;
    // eslint-disable-next-line no-param-reassign
    button.dataset.proposalId = data.proposalId;
  }

  if (!isActive && button.dataset.inactiveText) {
    // eslint-disable-next-line no-param-reassign
    button.lastChild.innerText = button.dataset.inactiveText;
  }
};

export const proposalButton = (button) => {
  eventBus.addEventListener(PROPOSAL_EVENT.ADDED, (event) => {
    document.querySelectorAll('[data-offer-proposal-button="on"]').forEach(
      (element) => {
        element.firstChild.classList.add('active');
      },
    );

    updateButtonLabel(true, button, event.detail);

    const { proposalId } = event.detail;
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('proposal_id')) {
      return;
    }

    // eslint-disable-next-line no-param-reassign
    button.dataset.proposalId = proposalId;
    urlParams.append('proposal_id', proposalId);
    window.history.pushState({}, document.title, decodeURIComponent(`${window.location.pathname}?${urlParams}`));
  });

  eventBus.addEventListener(PROPOSAL_EVENT.REMOVED, (event) => {
    document.querySelectorAll('[data-offer-proposal-button="on"]').forEach(
      (element) => {
        element.firstChild.classList.remove('active');
      },
    );

    locked = false;
    updateButtonLabel(false, button, event.detail);

    const urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.has('proposal_id')) {
      return;
    }

    button.removeAttribute('data-proposal-id');
    urlParams.delete('proposal_id');
    window.history.pushState({}, document.title, decodeURIComponent(`${window.location.pathname}?${urlParams}`));
  });

  eventBus.addEventListener(FAVORITE_PROPOSAL_EVENT.CANCEL_PROPOSAL_ADDITION, () => {
    locked = false;
  });

  button.addEventListener('click', () => {
    if (!isButtonActive(button)) {
      const urlParams = new URLSearchParams(document.location.search);
      const teamSizeList = urlParams.get('team-size-list') ?? null;
      const teamSize = urlParams.get('team-size') ?? null;
      const currentOffersHashId = getButtonHashIds(button);

      if (!currentOffersHashId) {
        Logger.error('No offersHashId found');
        return;
      }

      const offersHashId = JSON.parse(currentOffersHashId);

      eventBus.dispatchEvent(new CustomEvent(SelectionItemEvent.ADD_PROPOSAL, {
        detail: {
          offersHashId,
          teamSize,
          teamSizeList,
          origin: 'offer',
          refusedByUser: false,
        },
      }));

      return;
    }

    if (!locked) {
      const proposalId = getButtonProposalId(button);

      if (!proposalId) {
        flashBagError();
        Logger.error('No proposal ID provided');
        return;
      }

      locked = true;
      eventBus.dispatchEvent(new CustomEvent(SelectionItemEvent.ARCHIVE_PROPOSAL, {
        detail: {
          proposalId,
        },
      }));
    }
  });
};
